import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { addUser, deleteUser, updateUser, userSelector } from '../app/reducer/userReducer';

const userObj = {
  username: '',
  age: '',
};

export default function Home() {
  const dispatch = useDispatch();
  const userList = useSelector(userSelector);

  const [people, setPeople] = useState(userObj);

  const handleChange = (e) => {
    setPeople((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
  };

  const handleSubmit = () => {
    if (!people.username || !people.age) return;

    dispatch(
      addUser({
        id: uuidv4(),
        username: people.username,
        age: people.age,
      })
    );

    //! clearing
    setPeople(userObj);
  };

  const handleUpdate = (item) => {
    dispatch(updateUser({ id: item.id, username: people.username, age: people.age }));

    //! clearing
    setPeople(userObj);
  };

  //?############################################
  return (
    <div className='text-center Home'>
      <div
        className='modal modal-signin position-static d-block bg-secondary py-5'
        tabIndex='-1'
        role='dialog'
        id='modalSignin'
      >
        <div className='modal-dialog' role='document'>
          <div className='modal-content rounded-5 shadow'>
            <h2 className='fw-bold mb-0 my-2'>
              <u>Add New User</u>
            </h2>{' '}
            <br />
            <div className='modal-body p-5 pt-0'>
              <form className=''>
                <div className='form-floating mb-3'>
                  <input
                    type='text'
                    className='form-control rounded-4'
                    id='floatingInput'
                    placeholder='Enter Name..'
                    onChange={handleChange}
                    name='username'
                    value={people.username}
                    required={true}
                  />
                  <label htmlFor='floatingInput'>Enter Name</label>
                </div>
                <div className='form-floating mb-3'>
                  <input
                    type='number'
                    className='form-control rounded-4'
                    id='floatingPassword'
                    placeholder='Enter Age..'
                    onChange={handleChange}
                    name='age'
                    value={people.age}
                    required
                  />
                  <label htmlFor='floatingPassword'>Enter Age</label>
                </div>
              </form>
              <button className='w-100 mb-2 btn btn-lg rounded-4 btn-primary' type='submit' onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <>
        {userList.map((item) => {
          return (
            <div
              className='modal modal-alert position-static d-block bg-secondary'
              tabIndex='1'
              role='dialog'
              id='modalChoice'
              key={item.id}
            >
              <div className='modal-dialog' role='document'>
                <div className='modal-content rounded-4 shadow'>
                  <div className='modal-body p-4 text-center'>
                    <h5 className='mb-0'>Name - {item.username}</h5>
                    <h6 className='mb-0'>Age - {item.age}</h6>
                  </div>
                  <div className='modal-footer flex-nowrap p-0 text-center'>
                    <div className='input-group mb-3 ps-5'>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='update Name'
                        aria-label='Name'
                        aria-describedby='button-addon2'
                        name='username'
                        onChange={handleChange}
                        value={people.username}
                        required
                      />
                      <input
                        type='number'
                        className='form-control'
                        placeholder='update Age'
                        aria-label='Age'
                        aria-describedby='button-addon2'
                        name='age'
                        onChange={handleChange}
                        value={people.age}
                        required
                      />
                      <button
                        className='btn btn-outline-secondary'
                        type='button'
                        id='button-addon2'
                        onClick={() => handleUpdate(item)}
                      >
                        Button
                      </button>
                    </div>
                    <i
                      className='bi bi-trash-fill mx-4 '
                      onClick={() => {
                        dispatch(deleteUser({ id: item.id }));
                      }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </>
    </div>
  );
}
